export const FETCH_IF_NOT_FETCHED = 'FETCH_IF_NOT_FETCHED';
export const STALE_WHILE_REVALIDATE = 'STALE_WHILE_REVALIDATE';
export const FORCED_FETCH = 'FORCED_FETCH';
